import Candles from 'assets/candles.svg?react';
import Fireworks from 'assets/fireworks.svg?react';
import LibertyBell from 'assets/liberty-bell.svg?react';
import MortarPestle from 'assets/mortar-pestle.svg?react';
import Snowman from 'assets/snowman.svg?react';
import Turkey from 'assets/turkey.svg?react';

import {
    formatHour,
    ObservedHolidays,
} from 'components/liveReferrals/offHoursScreens/ObservedHolidays';
import { useGetLiveReferralHoursQuery } from 'store/api/auctionApi';

const getHolidayScreenProps = (holidayName: string) => {
    switch (holidayName) {
        case ObservedHolidays.NEW_YEARS_DAY:
        case ObservedHolidays.NEW_YEARS_DAY_SUBSTITUTE:
            return {
                icon: <Fireworks title="Fireworks" className="sds_fullscreen-page__icon" />,
                quote: 'Every moment is a fresh beginning.',
                quotee: 'T.S. Eliot',
                holiday: ObservedHolidays.NEW_YEARS_DAY,
            };
        case ObservedHolidays.MEMORIAL_DAY:
            return {
                icon: <Candles title="Candles" className="sds_fullscreen-page__icon" />,
                quote: 'As we express our gratitude, we must never forget that the highest appreciation is not to utter words but to live by them.',
                quotee: 'John F. Kennedy',
                holiday: ObservedHolidays.MEMORIAL_DAY,
            };
        case ObservedHolidays.INDEPENDENCE_DAY:
        case ObservedHolidays.INDEPENDENCE_DAY_SUBSTITUTE:
            return {
                icon: <LibertyBell title="Liberty Bell" className="sds_fullscreen-page__icon" />,
                quote: 'From every mountain side, let freedom ring',
                quotee: 'Martin Luther King Jr.',
                holiday: ObservedHolidays.INDEPENDENCE_DAY,
            };
        case ObservedHolidays.LABOR_DAY:
            return {
                icon: <MortarPestle title="Mortar Pestle" className="sds_fullscreen-page__icon" />,
                quote: 'The miracle is not that we do this work, but that we are happy to do it.',
                quotee: 'Mother Teresa',
                holiday: ObservedHolidays.LABOR_DAY,
            };
        case ObservedHolidays.THANKSGIVING_DAY:
            return {
                icon: <Turkey title="Turkey" className="sds_fullscreen-page__icon" />,
                quote: 'Showing gratitude is one of the simplest yet most powerful things humans can do for each other.',
                quotee: 'Randy Pausch',
                holiday: ObservedHolidays.THANKSGIVING_DAY,
            };
        case ObservedHolidays.CHRISTMAS_DAY:
        case ObservedHolidays.CHRISTMAS_DAY_SUBSTITUTE:
            return {
                icon: <Snowman title="Snowman" className="sds_fullscreen-page__icon" />,
                quote: "Christmas doesn't come from a store. Maybe Christmas perhaps means a little bit more.",
                quotee: 'Dr. Suess',
                holiday: ObservedHolidays.CHRISTMAS_DAY,
            };
        default:
            return {};
    }
};

interface HolidayScreenProps {
    holidayName: string;
}

export const HolidayScreen = ({ holidayName }: HolidayScreenProps) => {
    const { data } = useGetLiveReferralHoursQuery();
    const { icon, quote, quotee } = getHolidayScreenProps(holidayName);

    return (
        <div className="sds_fullscreen-page">
            <div className="sds_fullscreen-page__message-container">
                {icon}
                <div className="sds_fullscreen-page__holiday__default-text sds_fullscreen-page__holiday__default-text--closed padding__top--medium padding__bottom--medium">
                    Live Referrals are unavailable.
                </div>
                <div className="sds_fullscreen-page__holiday-quote padding__bottom--x-small">
                    &quot;{quote}&quot;
                </div>
                <div className="sds_fullscreen-page__holiday-quotee padding__bottom--large">
                    {quotee}
                </div>
                {data?.start && (
                    <div className="sds_fullscreen-page__holiday__default-text sds_fullscreen-page__holiday__default-text--reopen">
                        {`Live Referrals will be active on the next business day at ${formatHour(
                            data.start,
                        )}.`}
                    </div>
                )}
            </div>
        </div>
    );
};
